'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Refreshes the mediaQs depending on the viewport.
 */
var mediaQs = exports.mediaQs = function mediaQs() {

  return {

    // On device only
    'only-xs': window.innerWidth < 768,
    'only-sm': window.innerWidth >= 768 && window.innerWidth < 992,
    'only-md': window.innerWidth >= 992 && window.innerWidth < 1200,
    'only-lg': window.innerWidth >= 1200,
    // On device and up
    'from-xs': window.innerWidth > 0,
    'from-sm': window.innerWidth >= 768,
    'from-md': window.innerWidth >= 992,
    'from-lg': window.innerWidth >= 1200,
    // On device until
    'until-xs': window.innerWidth < 768,
    'until-sm': window.innerWidth < 992,
    'until-md': window.innerWidth < 1200,
    'until-lg': window.innerWidth > 0

  };
};

/**
 * Executes a callback only if the screen resolution matches the given
 * media query.
 *
 * @param  {String} mq               Media query to satisfy.
 * @param  {Object} $element         The (jquery) element as input to the callback functions.
 * @param  {Object} callback         Function to call in case of success.
 * @param  {Object} fallbackCallback (Optional) Function to call in case of failure.
 */
var respondTo = exports.respondTo = function respondTo(mq, $element, callback, fallbackCallback) {

  var mQs = mediaQs();

  if (mQs[mq] === true) {
    if (callback) {
      callback($element);
    }
  } else {
    if (fallbackCallback) {
      fallbackCallback($element);
    }
  }
};

/**
 * Retrieves a data attribute hosting the needed media query and call the
 * respondTo function with the given callback if the data-attribute matches
 * on of our media queries (FR_UTIL.mq).
 *
 * @param  {Object} $element         jQuery object to get the media query from.
 * @param  {Object} callback         Function to call in case of success.
 * @param  {Object} fallbackCallback (Optional) Function to call in case of failure.
 */
var respond = exports.respond = function respond($element, callback, fallbackCallback) {

  var mq = $element.attr('data-js-mq');
  var mQs = mediaQs();

  if (mq && mQs.hasOwnProperty(mq) && callback) {
    respondTo(mq, $element, callback, fallbackCallback);
  }
};

/**
 * Tells whether or not the device is a mobile device.
 *
 * @type {Object}
 */
var isMobile = exports.isMobile = {
  Android: function Android() {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function BlackBerry() {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function iOS() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function Opera() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function Windows() {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function any() {
    return this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows();
  }
};

/**
 * Changes image sizing based on viewport. Values set in `data-src-*` of the
 * img html tag.
 * @param  {Object} $element Element to resize.
 */
var responsiveImage = exports.responsiveImage = function responsiveImage($element) {

  var image = void 0;

  if (window.innerWidth >= 1200) {
    image = $element.attr('data-src-lg');
  } else if (window.innerWidth >= 992) {
    image = $element.attr('data-src-md');
  } else if (window.innerWidth >= 768) {
    image = $element.attr('data-src-sm');
  } else if (window.innerWidth > 0) {
    image = $element.attr('data-src-xs');
  }

  $element.attr('src', image);
};